<!-- @format -->

<header>
	<nav class="navbar navbar-expand-lg navbar-light">
		<a class="navbar-brand" href="#">
			<img src="/assets/images/dnv-logo.png" title="District Of North Vancouver" />
		</a>
		<h1>Timesheet App</h1>
		<span *ngIf="isTestEnv" class="testEnvHeading">UAT Environment</span>

		<div class="imageIconContainer" [class.noBorder]="profileImg" ngbDropdown>
			<button ngbDropdownToggle class="imageIconContainer">
				<ng-container *ngIf="profileImg" [class.noBorder]="profileImg">
					<img class="profile_icon" src="{{base64ProfilePhoto}}" />
				</ng-container>

				<div *ngIf="!profileImg" [class.noBorder]="profileImg">
					<i class="fa-solid fa-user" data-fa-transform="down-2" data-fa-mask="fa-solid fa-circle"></i>
				</div>
			</button>

			<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-end">
				<button ngbDropdownItem [routerLink]='["/profile"]' [class.active]="isCurrentActiveRoute('/profile')">Profile</button>
				<button
					ngbDropdownItem
					[routerLink]='["/team-profiles"]'
					[class.active]="isCurrentActiveRoute('/team-profiles')"
					*ngIf="isManagerOrTimeKeeper()">
					Team Profiles
				</button>
				<button ngbDropdownItem *ngIf="isAdmin()" [routerLink]='["/accounts"]' [class.active]='isCurrentActiveRoute("/accounts")'>
					Accounts
				</button>
				<button ngbDropdownItem [routerLink]='["/logout"]'>Log out</button>
			</div>
		</div>
	</nav>
</header>
<!-- <app-nav-menu *ngIf="router.url !== '/accessdenied'" [role]="role" [isDelegatedAsManager]="isDelegatedAsManager" [isLoadingData]="isLoadingData"></app-nav-menu> -->
<app-nav-menu *ngIf="router.url !== '/accessdenied'" [role]="role" [isLoadingData]="isLoadingData"></app-nav-menu>
